<template>
	<div class="login-register-page">
		<!-- 背景装饰元素 -->
		<div class="bg-decoration">
			<div class="bg-circle circle-1"></div>
			<div class="bg-circle circle-2"></div>
			<div class="bg-circle circle-3"></div>
		</div>

		<div class="login-register-wrapper">
			<!-- 左侧品牌信息 -->
			<div class="brand-section">
				<div class="brand-content">
					<div class="brand-logo">
						<span class="logo-icon">♈</span>
						<h1>白羊跨境</h1>
					</div>
					<h2 class="brand-title">定制单号轨迹测试系统</h2>
					<p class="brand-description">
						高效、智能、安全的物流管理系统<br>
						让每一次运输都精准可控
					</p>
					<div class="features">
						<div class="feature-item">
							<i class="el-icon-check"></i>
							<span>实时轨迹追踪</span>
						</div>
						<div class="feature-item">
							<i class="el-icon-check"></i>
							<span>智能订单管理</span>
						</div>
						<div class="feature-item">
							<i class="el-icon-check"></i>
							<span>数据分析报告</span>
						</div>
					</div>
				</div>
			</div>

			<!-- 右侧登录注册表单 -->
			<div class="form-section">
				<div class="form-card">
					<!-- 系统标题 -->
					<div class="system-title">
						<span class="title-text">欢迎使用</span>
						<div class="title-divider"></div>
					</div>

					<!-- 选项卡：登录/注册 -->
					<el-tabs v-model="activeTab" class="auth-tabs" @tab-click="handleTabChange">
						<!-- 登录面板 -->
						<el-tab-pane label="登录" name="login">
							<div class="tab-content">
								<h3 class="form-title">登录账户</h3>

								<el-form ref="loginForm" :model="loginForm" :rules="loginRules" label-width="0"
									class="auth-form login-form">
									<!-- 手机号输入 -->
									<el-form-item prop="phone">
										<el-input v-model="loginForm.phone" maxlength="11" show-word-limit
											@input="handlePhoneInput('login')" placeholder="请输入11位手机号"
											prefix-icon="el-icon-user" class="form-input"></el-input>
									</el-form-item>
									<br />
									<!-- 密码输入 -->
									<el-form-item prop="password">
										<el-input v-model="loginForm.password" show-password clearable maxlength="15"
											minlength="6" type="password" placeholder="请输入6-15位字母+数字组合密码"
											prefix-icon="el-icon-lock" class="form-input"></el-input>
									</el-form-item>
									<br />
									<!-- 记住我 + 忘记密码 -->
									<div class="form-extra">
										<el-checkbox v-model="loginForm.rememberMe" label="记住我"
											class="remember-me">记住我</el-checkbox>
										<el-link type="primary" @click="handleForgotPassword" class="forgot-password"
											:underline="false">忘记密码?</el-link>
									</div>

									<!-- 登录按钮 -->
									<el-form-item class="form-actions">
										<el-button type="primary" @click="handleLogin" class="btn-submit"
											:loading="loginLoading">
											立即登录
										</el-button>
									</el-form-item>

									<!-- 其他登录方式 -->
									<!-- <div class="other-login">
										<div class="other-login-line">
											<span>其他登录方式</span>
										</div>
									</div> -->
								</el-form>
							</div>
						</el-tab-pane>

						<!-- 注册面板 -->
						<el-tab-pane label="注册" name="register">
							<div class="tab-content">
								<h3 class="form-title">创建账户</h3>


								<el-form ref="registerForm" :model="registerForm" :rules="registerRules" label-width="0"
									class="auth-form register-form">
									<el-form-item prop="phone">
										<el-input v-model="registerForm.phone" maxlength="11" show-word-limit
											@input="handlePhoneInput('register')" placeholder="请输入11位手机号"
											prefix-icon="el-icon-mobile-phone" class="form-input"></el-input>
									</el-form-item>
									<br />
									<el-form-item prop="password">
										<el-input v-model="registerForm.password" show-password clearable maxlength="15"
											minlength="6" type="password" placeholder="请输入6-15位字母+数字组合密码"
											prefix-icon="el-icon-lock" class="form-input"></el-input>
									</el-form-item>
									<br />
									<el-form-item prop="confirmPassword">
										<el-input v-model="registerForm.confirmPassword" show-password clearable
											maxlength="15" minlength="6" type="password" placeholder="请再次输入密码"
											prefix-icon="el-icon-lock" class="form-input"></el-input>
									</el-form-item>
									<br />
									<el-form-item prop="inviteCode">
										<el-input v-model="registerForm.inviteCode" maxlength="5" placeholder="请输入5位邀请码"
											prefix-icon="el-icon-key" class="form-input"></el-input>
									</el-form-item>
									<br />
									<el-form-item class="form-actions">
										<el-button type="primary" @click="handleRegister" class="btn-submit"
											:loading="registerLoading">
											立即注册
										</el-button>
									</el-form-item>
								</el-form>
							</div>
						</el-tab-pane>
					</el-tabs>

					<!-- 底部版权信息 -->
					<div class="copyright">© 2025 白羊轨迹定制测试系统 v1.0.0</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// 引入表单验证工具
	import validator from 'validator'

	export default {
		name: 'LoginRegister',
		data() {
			// 自定义密码校验规则：6-15位字母+数字组合
			const validatePassword = function(rule, value, callback) {
				const reg = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{6,15}$/
				if (!value) {
					callback(new Error('请输入密码'))
				} else if (!reg.test(value)) {
					callback(new Error('密码必须是6-15位字母+数字组合'))
				} else {
					callback()
				}
			}

			return {
				activeTab: 'login', // 默认显示登录页
				loginLoading: false, // 登录按钮加载状态
				registerLoading: false, // 注册按钮加载状态
				phoneInputTimer: null, // 手机号输入防抖定时器

				// 登录表单数据（新增rememberMe字段）
				loginForm: {
					phone: '',
					password: '',
					rememberMe: false // 记住我勾选状态
				},

				// 注册表单数据
				registerForm: {
					phone: '',
					password: '',
					confirmPassword: '',
					inviteCode: ''
				},

				// 登录表单校验规则
				loginRules: {
					phone: [{
							required: true,
							message: '请输入手机号',
							trigger: 'blur'
						},
						{
							validator: function(rule, value, callback) {
								if (value && !validator.isMobilePhone(value, 'zh-CN')) {
									callback(new Error('请输入正确的11位手机号'))
								} else {
									callback()
								}
							},
							trigger: 'blur'
						}
					],
					password: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							validator: validatePassword,
							trigger: 'blur'
						}
					]
				},

				// 注册表单校验规则（优化邀请码长度、确认密码校验）
				registerRules: {
					phone: [{
							required: true,
							message: '请输入手机号',
							trigger: 'blur'
						},
						{
							validator: function(rule, value, callback) {
								if (value && !validator.isMobilePhone(value, 'zh-CN')) {
									callback(new Error('请输入正确的11位手机号'))
								} else {
									callback()
								}
							},
							trigger: 'blur'
						}
					],
					password: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							validator: validatePassword,
							trigger: 'blur'
						}
					],
					confirmPassword: [{
							required: true,
							message: '请确认密码',
							trigger: 'blur'
						},
						{
							validator: this.validateConfirmPassword,
							trigger: 'blur'
						}
					],
					inviteCode: [{
						required: true,
						message: '请输入邀请码',
						trigger: 'blur'
					}, {
						min: 5,
						max: 5,
						message: '邀请码必须为5位',
						trigger: 'blur'
					}, {
						validator: (rule, value, callback) => {
							const reg = /^[a-zA-Z0-9]{5}$/ // 5位字母/数字组合
							if (!reg.test(value)) {
								callback(new Error('邀请码仅支持字母和数字'))
							} else {
								callback()
							}
						},
						trigger: 'blur'
					}]
				}
			}
		},
		methods: {
			// 确认密码校验方法（移到methods避免this指向问题）
			validateConfirmPassword(rule, value, callback) {
				if (!value) {
					callback(new Error('请确认密码'))
				} else if (value !== this.registerForm.password) {
					callback(new Error('两次输入的密码不一致'))
				} else {
					callback()
				}
			},

			// 手机号输入防抖处理
			handlePhoneInput(type) {
				clearTimeout(this.phoneInputTimer)
				this.phoneInputTimer = setTimeout(() => {
					const form = type === 'login' ? this.loginForm : this.registerForm
					form.phone = form.phone.replace(/[^\d]/g, '')
				}, 300)
			},

			// Cookie操作封装
			setCookie(key, value, days = 7) {
				const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString()
				document.cookie = `${key}=${encodeURIComponent(value)}; expires=${expires}; path=/`
			},
			getCookie(key) {
				const cookies = document.cookie.split('; ').reduce((acc, cookie) => {
					const [k, v] = cookie.split('=')
					acc[k] = decodeURIComponent(v)
					return acc
				}, {})
				return cookies[key] || ''
			},
			removeCookie(key) {
				document.cookie = `${key}=; expires=${new Date(0).toUTCString()}; path=/`
			},

			// 设置"记住我"Cookie（仅存储手机号，密码不存储）
			setRememberMeCookie(phone) {
				try {
					// 简单加密：Base64编码
					const encryptPhone = btoa(phone)
					this.setCookie('remember_phone', encryptPhone, 7)
				} catch (err) {
					console.error('设置记住我Cookie失败：', err)
				}
			},
			// 清除"记住我"Cookie
			clearRememberMeCookie() {
				this.removeCookie('remember_phone')
			},
			// 读取"记住我"Cookie（仅回显手机号）
			getRememberMeCookie() {
				try {
					const encryptPhone = this.getCookie('remember_phone')
					if (encryptPhone) {
						const phone = atob(encryptPhone) // 解密
						// 二次校验手机号格式
						if (/^1[3-9]\d{9}$/.test(phone)) {
							this.loginForm.phone = phone
							this.loginForm.rememberMe = true
						} else {
							this.clearRememberMeCookie() // 格式错误则清除
						}
					}
				} catch (err) {
					console.error('读取记住我Cookie失败：', err)
					this.clearRememberMeCookie()
				}
			},

			// 切换选项卡时重置表单
			handleTabChange: function handleTabChange() {
				if (this.activeTab === 'login') {
					// 替换 ?. 为 && 判空
					if (this.$refs.registerForm) {
						this.$refs.registerForm.resetFields();
					}
				} else {
					if (this.$refs.loginForm) {
						this.$refs.loginForm.resetFields();
					}
				}
			},

			// 登录方法（仅保留一份，修复参数映射+安全处理）
			handleLogin() {
				this.loginLoading = true
				this.$axios.post('/login', {
					mobile: this.loginForm.phone,
					password: this.loginForm.password
				}).then((res) => {
					if (res.code === 200) {
						// 存储token到localStorage
						localStorage.setItem('token', res.data.token)

						// 存储完整的用户信息和额外数据
						const userInfo = res.data.user_info

						// 单独存储重要字段，方便Home页面直接使用
						localStorage.setItem('user_id', userInfo.id) // 存储用户ID
						localStorage.setItem('user_mobile', userInfo.mobile) // 存储手机号
						localStorage.setItem('user_balance', userInfo.balance) // 存储余额
						localStorage.setItem('user_type', userInfo.user_type) // 存储用户类型
						localStorage.setItem('user_status', userInfo.status) // 存储用户状态

						// 存储完整的用户信息对象（JSON格式）
						localStorage.setItem('user_info', JSON.stringify(userInfo))

						// 存储登录相关数据
						localStorage.setItem('login_time', res.data.login_time)
						localStorage.setItem('login_ip', res.data.login_ip)
						localStorage.setItem('token_expire', res.data.token_expire)

						// 设置记住我cookie
						if (this.loginForm.rememberMe) {
							this.setRememberMeCookie(this.loginForm.phone)
						} else {
							this.clearRememberMeCookie()
						}

						this.$message.success(res.msg || '登录成功')

						// 跳转到首页
						this.$router.push('/home')
					} else {
						this.$message.warning(res.msg || '登录失败')
					}
				}).catch((err) => {
					const errMsg = err.response.data.msg || '服务器错误，请稍后重试'
					this.$message.error('登录失败：' + errMsg)
				}).finally(() => {
					this.loginLoading = false
				})
			},

			// 注册处理方法（适配：无验证码、有邀请码）
			handleRegister() {
				// 1. 表单校验（仅校验你实际的字段：手机号、密码、确认密码、邀请码）
				if (!this.registerForm.phone || !/^1[3-9]\d{9}$/.test(this.registerForm.phone)) {
					this.$message.warning('请输入正确的手机号');
					return;
				}
				if (this.registerForm.password !== this.registerForm.confirmPassword) {
					this.$message.warning('两次密码输入不一致');
					return;
				}
				// 邀请码如果是选填，可去掉这个校验；如果是必填，保留
				// if (!this.registerForm.inviteCode) {
				//   this.$message.warning('请输入邀请码');
				//   return;
				// }

				this.registerLoading = true; // 开启注册加载态（需在data中定义：registerLoading: false）
				this.$axios.post('/register', {
					mobile: this.registerForm.phone,
					password: this.registerForm.password,
					invite_code: this.registerForm.inviteCode, // 替换为邀请码字段，删除验证码相关
					// 其他你实际需要的注册参数
				}).then((res) => {
					// 只处理后端正常返回的响应（成功/业务错误）
					if (res.code === 200) {
						// 注册成功逻辑
						this.$message.success('注册成功，请登录');
						// 切换到登录标签页（根据你的实际tab绑定字段调整，比如currentTab）
						this.activeTab = 'login';
						// 清空注册表单
						this.registerForm = {
							phone: '',
							password: '',
							confirmPassword: '',
							invite_code: '' // 清空邀请码，而非验证码
						};
					} else {
						// 后端返回的业务错误（如手机号已注册、邀请码无效等），仅提示一次
						this.$message.error(res.msg || '注册失败');
					}
				}).catch((err) => {
					// 仅处理系统级错误（断网、服务器500、接口404等）
					const errMsg = err.response.data.msg || err.message || '服务器错误，请稍后重试';
					this.$message.error('注册失败：' + errMsg);
				}).finally(() => {
					this.registerLoading = false; // 关闭加载态
				});
			},

			// 忘记密码点击事件
			handleForgotPassword() {
				this.$message.warning('请联系微信客服：byqggzs01，找回密码。')
			},
		},

		// 页面加载时读取Cookie
		mounted() {
			this.getRememberMeCookie()
		}
	}
</script>

<style scoped>
	/* 基础样式 */
	.login-register-page {
		width: 100%;
		min-height: 100vh;
		background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 20px;
		position: relative;
		overflow: hidden;
		box-sizing: border-box;
	}

	/* 背景装饰 */
	.bg-decoration {
		position: absolute;
		width: 100%;
		height: 100%;
		z-index: 0;
	}

	.bg-circle {
		position: absolute;
		border-radius: 50%;
		background: rgba(255, 255, 255, 0.1);
	}

	.circle-1 {
		width: 400px;
		height: 400px;
		top: -200px;
		right: -200px;
	}

	.circle-2 {
		width: 300px;
		height: 300px;
		bottom: -150px;
		left: -150px;
	}

	.circle-3 {
		width: 200px;
		height: 200px;
		top: 50%;
		left: 10%;
	}

	/* 登录包装器 */
	.login-register-wrapper {
		width: 100%;
		max-width: 1200px;
		background: rgba(255, 255, 255, 0.95);
		border-radius: 24px;
		box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
		display: flex;
		overflow: hidden;
		backdrop-filter: blur(10px);
		z-index: 1;
		min-height: 700px;
	}

	/* 左侧品牌区域 */
	.brand-section {
		flex: 1;
		background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
		color: white;
		padding: 60px 40px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		position: relative;
		overflow: hidden;
	}

	.brand-section::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="%23ffffff" fill-opacity="0.1" d="M0,128L48,112C96,96,192,64,288,48C384,32,480,32,576,42.7C672,53,768,75,864,101.3C960,128,1056,160,1152,149.3C1248,139,1344,85,1392,58.7L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg>');
		background-size: cover;
		opacity: 0.5;
	}

	.brand-content {
		position: relative;
		z-index: 1;
	}

	.brand-logo {
		display: flex;
		align-items: center;
		/* 水平排列，居中对齐 */
		gap: 16px;
		margin-bottom: 24px;
		justify-content: center;
		/* 整个组合居中 */
		width: auto;
		/* 改为自适应宽度 */
	}

	.logo-icon {
		font-size: 48px;
		background: rgba(255, 255, 255, 0.2);
		width: 80px;
		height: 80px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		backdrop-filter: blur(4px);
		border: 2px solid rgba(255, 255, 255, 0.3);
	}

	.brand-logo h1 {
		font-size: 36px;
		font-weight: 700;
		margin: 0;
		background: linear-gradient(to right, #fff, #f8f8f8);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		background-clip: text;
	}

	.brand-title {
		font-size: 28px;
		font-weight: 600;
		margin-bottom: 16px;
		opacity: 0.9;
	}

	.brand-description {
		font-size: 16px;
		line-height: 1.8;
		opacity: 0.8;
		margin-bottom: 40px;
	}

	.features {
		display: flex;
		flex-direction: column;
		gap: 16px;
		align-items: center;
		/* 添加这行让功能项居中 */
		text-align: center;
	}

	.feature-item {
		display: flex;
		align-items: center;
		gap: 12px;
		font-size: 16px;
		justify-content: center;
		/* 确保每行内容居中 */
		opacity: 0.9;
	}

	.feature-item i {
		color: #FFD700;
		font-size: 18px;
	}

	/* 右侧表单区域 */
	.form-section {
		flex: 1.2;
		padding: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.form-card {
		width: 100%;
		max-width: 500px;
	}

	/* 系统标题 */
	.system-title {
		text-align: center;
		margin-bottom: 30px;
	}

	.title-text {
		font-size: 24px;
		font-weight: 600;
		color: #1e293b;
		display: inline-block;
		position: relative;
	}

	.title-divider {
		width: 60px;
		height: 3px;
		background: linear-gradient(135deg, #667eea, #764ba2);
		border-radius: 3px;
		margin: 15px auto 0;
	}

	/* 选项卡样式 */
	.auth-tabs {
		width: 100%;
	}

	:deep(.auth-tabs .el-tabs__nav-wrap::after) {
		display: none;
	}

	:deep(.auth-tabs .el-tabs__item) {
		font-size: 18px !important;
		font-weight: 600 !important;
		height: 60px !important;
		line-height: 60px !important;
		padding: 0 30px !important;
		color: #64748b !important;
	}

	:deep(.auth-tabs .el-tabs__active-bar) {
		height: 4px !important;
		border-radius: 2px !important;
		background: linear-gradient(135deg, #667eea, #764ba2) !important;
	}

	:deep(.auth-tabs .el-tabs__item.is-active) {
		color: #667eea !important;
	}

	/* 表单内容 */
	/* .tab-content {
		padding: 20px 0;
	} */

	.form-title {
		font-size: 28px;
		font-weight: 700;
		color: #1e293b;
		margin-bottom: 8px;
	}

	.form-subtitle {
		font-size: 16px;
		color: #64748b;
		margin-bottom: 32px;
	}

	/* 表单样式 */
	.auth-form {
		width: 100%;
		margin-top: 24px;
	}

	:deep(.el-form-item) {
		margin-bottom: 24px;
	}

	:deep(.form-input .el-input__inner) {
		height: 52px !important;
		font-size: 16px !important;
		border-radius: 12px !important;
		border: 1px solid #e2e8f0 !important;
		padding-left: 48px !important;
		transition: all 0.3s ease !important;
	}

	:deep(.form-input .el-input__inner:hover) {
		border-color: #cbd5e1 !important;
	}

	:deep(.form-input .el-input__inner:focus) {
		border-color: #667eea !important;
		box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1) !important;
	}

	:deep(.form-input .el-input__prefix) {
		left: 16px !important;
	}

	:deep(.form-input .el-input__icon) {
		font-size: 18px !important;
		color: #94a3b8 !important;
	}

	/* 记住我 + 忘记密码 */
	.form-extra {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 24px;
		padding: 0 2px;
	}

	:deep(.remember-me .el-checkbox__label) {
		font-size: 14px !important;
		color: #64748b !important;
	}

	.forgot-password {
		font-size: 14px !important;
		color: #667eea !important;
	}

	/* 按钮样式 */
	.form-actions {
		margin-top: 5px;
	}

	.btn-submit {
		width: 100%;
		height: 52px;
		font-size: 16px;
		font-weight: 600;
		border-radius: 12px;
		background: linear-gradient(135deg, #667eea, #764ba2);
		border: none;
		transition: all 0.3s ease;
	}

	.btn-submit:hover {
		transform: translateY(-2px);
		box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
	}

	/* 其他登录方式样式 */
	.other-login {
		margin-top: 32px;
		text-align: center;
	}

	.other-login-line {
		position: relative;
		text-align: center;
		margin-bottom: 20px;
		color: #94a3b8;
		font-size: 14px;
	}

	.other-login-line::before,
	.other-login-line::after {
		content: '';
		position: absolute;
		top: 50%;
		width: 45%;
		height: 1px;
		background: #e2e8f0;
	}

	.other-login-line::before {
		left: 0;
	}

	.other-login-line::after {
		right: 0;
	}

	.other-login-icons {
		display: flex;
		justify-content: center;
		gap: 30px;
	}

	.login-icon {
		font-size: 28px;
		color: #64748b;
		cursor: pointer;
		transition: all 0.3s ease;
		padding: 8px;
		border-radius: 50%;
	}

	.login-icon:hover {
		color: #667eea;
		background: rgba(102, 126, 234, 0.1);
	}

	.el-icon-chat-dot-round:hover {
		color: #07C160;
		background: rgba(7, 193, 96, 0.1);
	}

	.el-icon-qq:hover {
		color: #12B7F5;
		background: rgba(18, 183, 245, 0.1);
	}

	.el-icon-weibo:hover {
		color: #E6162D;
		background: rgba(230, 22, 45, 0.1);
	}

	/* 版权信息 */
	.copyright {
		text-align: center;
		margin-top: 40px;
		padding-top: 20px;
		border-top: 1px solid #e2e8f0;
		color: #94a3b8;
		font-size: 14px;
	}

	/* 响应式调整 */
	@media (max-width: 992px) {
		.login-register-wrapper {
			flex-direction: column;
			max-width: 500px;
			min-height: auto;
		}

		.brand-section {
			padding: 40px 20px;
			text-align: center;
		}

		.form-section {
			padding: 30px 20px;
		}

		.logo-icon {
			width: 60px;
			height: 60px;
			font-size: 36px;
		}

		.brand-logo {
			justify-content: center;
		}

		.brand-logo h1 {
			font-size: 28px;
		}

		.brand-title {
			font-size: 24px;
		}
	}

	@media (max-width: 576px) {
		.login-register-page {
			padding: 10px;
		}

		.login-register-wrapper {
			border-radius: 16px;
		}

		:deep(.auth-tabs .el-tabs__item) {
			font-size: 16px !important;
			padding: 0 20px !important;
		}

		.other-login-icons {
			gap: 20px;
		}

		.login-icon {
			font-size: 24px;
		}
	}
</style>